export default ['JsonRPCService', function (JsonRPCService) {
    return {
        getAccountPolicySummaries: function getAccountPolicySummaries() {
            return JsonRPCService.send('pc', 'policy/policy', 'getAccountPolicySummaries', []);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/services/PolicyService.js
// module id = 860
// module chunks = 0